import { useThree } from '@react-three/fiber'
import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { GLTFModel } from './GLTFModel'
import { useAssetVizData } from '@asset-viz/providers/data'
import React from 'react'
import * as THREE from 'three'

export const GLTFLoader: React.FC = () => {
  const { focusedCDF } = useAssetVizInternal()
  const { camera } = useThree()

  const { useResolveAssetUrl } = useAssetVizData()
  const { url: componentUrl = '', isLoading } = useResolveAssetUrl({
    entryId: focusedCDF?.tags.component || '',
    path: 'images/model.glb',
  })

  const handleBoundsReady = React.useCallback(
    (bbox: THREE.Box3) => {
      const center = bbox.getCenter(new THREE.Vector3())
      const size = bbox.getSize(new THREE.Vector3())
      const maxDim = Math.max(size.x, size.y, size.z)

      // Set camera position based on the actual size
      // Position camera at 45 degree angle from the front
      const distance = maxDim
      camera.position.set(
        center.x + distance * 0.8,
        center.y,
        center.z + distance * 0.8
      )
      camera.lookAt(center)

      // Adjust camera frustum based on actual size
      camera.near = maxDim / 100
      camera.far = maxDim * 10
      camera.updateProjectionMatrix()
    },
    [camera]
  )

  return (
    <group>
      {/* Conditionally render GLTFModel only when componentUrl is available */}
      {!isLoading && componentUrl && (
        <GLTFModel url={componentUrl} onBoundsReady={handleBoundsReady} />
      )}
    </group>
  )
}
